module.exports = __webpack_public_path__ + "img/1.e556e4ff.png";